module.exports = __webpack_public_path__ + "static/Prototypes2x-1eaed4d098bfe84307e9cfd3236d1daf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-invision/Prototypes2x.jpg
// module id = 2661
// module chunks = 260617349216052